import React from 'react';
import Routes from 'routes';
import {connect} from 'react-redux';
import {withApp} from 'helpers';
import {Col, Container, Row} from 'react-grid-system';
import EndIntroimg from '../assets/Test.svg';
import {Endtest} from 'content';
import {translate} from 'translations';
import * as accountActions from 'store/actions/accountActions';
import {bindActionCreators} from "redux";
import {
  Animation,
  Button,
  ButtonsGroup,
  Heading,
  Image,
  Page,
  PageContent,
  PageFooter,
  PageTitle,
  Text
} from 'components/library';

class EndtestIntroPage extends React.Component {
  componentDidMount() {
    const nav = this.props.navigation.find(item => item.type === 'endtest')
    this.props.app.triggerTheme(nav.theme || 'default')
  }

  handleRestart = e => {
    if (!this.props.endtest.passed) {
      this.props.accountActions.updateEndtest({
        completed: false,
        passed: false,
        score: 0,
        answers: [],
      })
    }
  };

  render() {
    return (
        <Page>
          <Animation name="slideInDown" delay={100}>
            <PageTitle>
              <Heading h1>{this.props.endtest.intro.title}</Heading>
              <Heading em>{this.props.endtest.intro.description}</Heading>
            </PageTitle>
          </Animation>

          <Animation delay={200}>
            <PageContent>
              <Container>
                <Row>
                  <Col sm={7}>
                    <Text>Deze toets bestaat uit 10 vragen, waarmee je in totaal 10 punten kunt halen. Bij elke vraag
                      kun je dus 1 punt halen.</Text>
                    <Text style={{margin: '3rem 0'}}>Aan het eind van de zelftoets kun je alle vragen en antwoorden
                      inzien, om te ontdekken wat er goed en minder goed ging. We geven dan ook aan welke hoofdstukken
                      je het beste nog even kunt doornemen.</Text>
                    <Text style={{margin: '3rem 0 0'}}>Mocht je de eerste keer geen 10 punten halen dan kun je de
                      zelftoets nog een keer maken.</Text>
                    {this.props.progress.completed &&
                    <React.Fragment>
                      <Text style={{margin: '3rem 0 0'}}>Je hebt deze toets reeds voltooid. Als je de toets opnieuw
                      wilt maken, kun je met de onderstaande knop de antwoorden wissen:</Text>
                      <Button square outline onClick={this.handleRestart} label={"Antwoorden wissen"}/>
                    </React.Fragment>
                    }
                  </Col>
                  <Col sm={5}>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                      <Image style={{width: '20rem'}} src={EndIntroimg} aspectRatio={91}/>
                    </div>
                  </Col>
                </Row>
              </Container>
            </PageContent>
          </Animation>

          <Animation delay={300}>
            <PageFooter>
              <div className="Page-footer-left">
                <Button outline to={Routes.to('home')} icon="home"/>
              </div>

              <div className="Page-footer-right">
                <div></div>
                <ButtonsGroup>
                  <Button primary square to={Routes.to('endtestTest')} label={translate('endtest.btnStart')}/>
                </ButtonsGroup>
              </div>
            </PageFooter>
          </Animation>
        </Page>
    )
  }
}

export default withApp(connect(
    (state, props) => ({
      endtest: Endtest,
      progress: state.account.endtest,
      navigation: state.content.navigation,
    }),
    (dispatch) => ({
      accountActions: bindActionCreators(accountActions, dispatch)
    })
)(EndtestIntroPage))



// WEBPACK FOOTER //
// ./src/components/views/endtest/components/IntroPage.js